
import React from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import PieChartDisplay from "../charts/PieChartDisplay";

interface DamageReason {
  name: string;
  value: number;
  percentage: number;
}

interface DamageReasonsProps {
  damageReasons: DamageReason[];
}

const DamageReasons: React.FC<DamageReasonsProps> = ({ damageReasons }) => {
  return (
    <section className="space-y-4">
      <h2 className="text-xl font-semibold">2. 📈 Top 5 Schaderedenen</h2>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Verdeling schaderedenen</CardTitle>
            <CardDescription>Overzicht van alle oorzaken</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-80">
              <PieChartDisplay 
                data={damageReasons} 
                showLabel={true}
                labelLines={true}
                fontSize={14}
              />
            </div>
          </CardContent>
        </Card>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Schaderedenen in detail</CardTitle>
            <CardDescription>Tabel met percentages</CardDescription>
          </CardHeader>
          <CardContent>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Reden</TableHead>
                  <TableHead className="text-right">Aantal</TableHead>
                  <TableHead className="text-right">Percentage</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {damageReasons.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.name}</TableCell>
                    <TableCell className="text-right">{item.value}</TableCell>
                    <TableCell className="text-right">{item.percentage}%</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            
            <div className="mt-4">
              <h3 className="font-medium mb-2">🔎 Feiten:</h3>
              <ul className="list-disc pl-6 space-y-1">
                <li>Verzendlabelproblemen zijn veruit de grootste oorzaak van schade.</li>
                <li>Retouren en transportproblemen zijn samen goed voor bijna de helft van alle meldingen.</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default DamageReasons;
